import { PartakerDTO } from "../definitions";
import { cdn } from "@/utils/cdn";

export class PartakerModel {
  readonly id: number;
  readonly fullName: string;
  readonly imageCard: string;
  readonly profession: string;

  constructor(partakerDTO: PartakerDTO) {
    this.id = partakerDTO.id;
    this.fullName = partakerDTO.full_name;
    this.imageCard = partakerDTO.image_card;
    this.profession = partakerDTO.profession;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getImageCard(resize: any, options: any) {
    return cdn(this.imageCard, resize, options);
  }
}
